import Link from 'next/link'
import { useRouter } from 'next/router'
import { FC, ReactNode } from 'react'
import classNames from 'classnames'

export interface ActiveLinkType {
  href?: string
  match?: any
  as?: string
  activeClassName?: string
  className?: string
  children?: ReactNode
}

const ActiveLink: FC<ActiveLinkType> = ({
  href = '',
  match,
  as = href,
  activeClassName = 'active',
  className,
  children,
  ...rest
}) => {
  const router = useRouter()
  // @ts-ignore
  let isActive = false
  if (
    (router.asPath === href && activeClassName) ||
    (match && (router.asPath || router.pathname).match(match))
  ) {
    isActive = true
  }

  return (
    <Link
      className={classNames(className, isActive ? activeClassName : '')}
      as={as}
      href={href}
      aria-current={isActive ? 'page' : undefined}
      {...rest}
    >
      {/*@ts-ignore*/}
      {children}
    </Link>
  )
}

export default ActiveLink
